<!--
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-14 15:50:49
 * @LastEditTime: 2026-04-17 16:00:00
 * @LastEditors: ranli
-->
<template>
  <div class="app-layout">
    <CHeader
      v-if="showHeader"
      :title="headerTitle"
      :subtitle="headerSubtitle"
      :status-type="headerStatusType"
      :show-status-badge="headerShowStatusBadge"
      :status-text="headerStatusText"
    />
    <TopTabs v-if="layout === 'top-tab'" />
    <div class="app-layout-content" :class="contentClass">
      <router-view v-slot="{ Component, route }">
        <keep-alive v-if="route.meta.keepAlive">
          <component :is="Component" :key="route.name || route.path" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
    <TabBar v-if="showTabBar" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import CHeader from '@/components/CHeader/index.vue'
import TopTabs from '@/components/TopTabs/index.vue'
import TabBar from '@/components/TabBar/index.vue'
import { useHeader } from '@/composables/useHeader.js'

const route = useRoute()
const {
  title: headerTitle,
  subtitle: headerSubtitle,
  statusType: headerStatusType,
  showStatusBadge: headerShowStatusBadge,
  statusText: headerStatusText,
} = useHeader()

const layout = computed(() => route.meta.layout || 'inner')
const showHeader = computed(() => layout.value === 'inner')
const showTabBar = computed(() => layout.value === 'tab')

const contentClass = computed(() => {
  return {
    'has-header': showHeader.value,
    'has-tabs': layout.value === 'top-tab',
    'has-tabbar': showTabBar.value,
  }
})
</script>

<style scoped lang="less">
.app-layout {
  min-height: 100vh;

  &-content {
    &.has-header {
      padding-top: 44px;
    }

    &.has-tabbar {
      padding-bottom: 50px;
    }
  }
}
</style>
